if (!customElements.get('design-studio-picker')) {
    class DesignStudioPicker extends HTMLElement {
        constructor() {
            super();
            this.section = this.closest('.js-product');
            this.productForm = this.section.querySelector('.js-product-form-main');
            
             //   this.attachShadow({ mode: 'open' });


        }
        connectedCallback() {
            //  标记为未就绪，并禁用所有现有 input
            this._isReady = false;
            this.disableInputs();

            this.BADGE_SELECTED = 'fill: rgb(255, 255, 255); color: rgb(255, 255, 255); border: 0px solid rgb(225, 225, 225); background-color: rgb(67, 67, 67);';
            this.BADGE_UNSELECTED = 'background-color: rgb(255, 255, 255); fill: rgb(67, 67, 67); color: rgb(67, 67, 67); border: 0px solid rgb(225, 225, 225);';

            this.data = this.getDesignStudioData();
            this.currencyIsoCode = this.data?this.data.currencyIsoCode:'';
            //this.currentTab = this.getCurrentTab();
            this.resetDefaultSelected();

            //  所有初始化完成后，标记为就绪，并启用 input
            this._isReady = true;
            this.enableInputs();

            this.addEventListener('change', this.handleChange.bind(this));
            this.addEventListener('click', this.handleBadgeClick.bind(this));

            this.selectedSerie=this.data?this.data.selectedSerie:'';
            this.selectedData();
            this.updateSummary2('all');
            
        }

        // 禁用所有选项
        disableInputs() {
            this.querySelectorAll('.opt-btn').forEach(input => input.disabled = true);
        }

        // 启用所有选项
        enableInputs() {
            this.querySelectorAll('.opt-btn').forEach(input => input.disabled = false);
        }

        resetDefaultSelected(){
            this.selectedSerie='';
            this.selectedWatchhead=[];
            this.selectedWatchbezel1=[];
            this.selectedWatchbezel2=[];
            this.selectedWatchbezel3=[];
            this.selectedWatchbezel4=[];
            this.selectedWatchbezel5=[];
            this.selectedWatchbezel6=[];
            this.selectedWatchstrap=[];
            this.selectedWatchcrown=[];
            this.configuration={
                'watchhead':0,
                'watchbezel1':0,
                'watchbezel2':0,
                'watchbezel3':0,
                'watchbezel4':0,
                'watchbezel5':0,
                'watchbezel6':0,
                'watchstrap':0,
                'watchcrown':0
            }
        }

        selectedData(){
            //设置系列
            if(this.selectedSerie){
                 // 查找匹配的数据项
                const matched = this.data.allSeriesData.find(item => item.watchserie === this.selectedSerie);
                if (!matched) return;
               //设置表头默认选项
                this.selectedWatchhead = this.getSelectedByKey(this.selectedSerie,'watchheadProductFormatted');
                this.selectedWatchbezel1 = this.getSelectedByKey(this.selectedSerie,'watchbezelProduct1Formatted');
                this.selectedWatchbezel2 = this.getSelectedByKey(this.selectedSerie,'watchbezelProduct2Formatted');
                this.selectedWatchbezel3 = this.getSelectedByKey(this.selectedSerie,'watchbezelProduct3Formatted');
                this.selectedWatchbezel4 = this.getSelectedByKey(this.selectedSerie,'watchbezelProduct4Formatted');
                this.selectedWatchbezel5 = this.getSelectedByKey(this.selectedSerie,'watchbezelProduct5Formatted');
                this.selectedWatchbezel6 = this.getSelectedByKey(this.selectedSerie,'watchbezelProduct6Formatted');
                this.selectedWatchstrap = this.getSelectedByKey(this.selectedSerie,'watchstrapProductFormatted');
                this.selectedWatchcrown = this.getSelectedByKey(this.selectedSerie,'watchcrownProductFormatted');
                //console.log(JSON.stringify(this.selectedWatchhead))
                //console.log(JSON.stringify(this.selectedWatchbezel1))
                //console.log(JSON.stringify(this.selectedWatchbezel2))
                //console.log(JSON.stringify(this.selectedWatchbezel3))
                //console.log(JSON.stringify(this.selectedWatchbezel4))
                //console.log(JSON.stringify(this.selectedWatchbezel5))
                //console.log(JSON.stringify(this.selectedWatchbezel6))
                //console.log(JSON.stringify(this.selectedWatchstrap))
                //console.log(JSON.stringify(this.selectedWatchcrown))
            }
            
        }

        //默认选中值
        getSelectedByKey(selectedSerie,formattedKey){
            const matched = this.data.allSeriesData?.find(item => item.watchserie === selectedSerie);
            if (!matched) return [];
            const formatted = matched[formattedKey];
            if(!formatted) return [];
            
            let objArr=[];
            Object.keys(formatted).forEach(key => {
                if (formatted[key] && typeof formatted[key] === 'object') {
                    if(formatted[key].is_select){
                        let obj={}
                        obj.id=key;
                        obj.price=formatted[key].price;
                        obj.title=formatted[key].title
                        obj.priceNumber= formatted[key].priceNumber;
                        obj.viewerMedia = formatted[key].viewerMedia;
                        objArr.push(obj);
                    }
                }
            });

            return objArr;
        }
        //
        getSelectedByKeyVariantId(selectedSerie,formattedKey,variantId){
            const matched = this.data.allSeriesData?.find(item => item.watchserie === selectedSerie);
            if (!matched) return null; // 找不到系列

            const formatted = matched[formattedKey];
            if (!formatted || typeof formatted !== 'object') return null;

            const variantFormatted = formatted[variantId];
            if (!variantFormatted) return null;

            // 返回选中项的对象
            return {
                id: variantId,         
                price: variantFormatted.price,
                title: variantFormatted.title,
                priceNumber: variantFormatted.priceNumber,
                viewerMedia:variantFormatted.viewerMedia,
            };
        };
        updateConfigurationList(selectArr,type){
            const blcokEl=this.querySelector(`.panel-configuration .${type}`);
            if(blcokEl){
                let elHtml='';
                selectArr.forEach((item, idx)=>{
                    elHtml += `<li class="flex items-center justify-between gap-4 text-sm"><span class="text-foreground-muted">${item.title}</span><span class="inline-flex flex-col items-end">${item.price}</span></li>
                    `;

                })
                blcokEl.innerHTML = elHtml;
                //console.log(type)
                const blockDiv=blcokEl.closest('.configuration-block');
                if(blockDiv){
                    const blockLeftEl = blockDiv.querySelector('.block-left');
                    if (blockLeftEl) {
                        let arrLen=selectArr.length
                        if( type=='watchbezel1' ||  type=='watchbezel2' ||  type=='watchbezel3'  || type=='watchbezel4' ||  type=='watchbezel5' ||  type=='watchbezel6'){
                            const allSelected = [
                                ...this.selectedWatchbezel1,
                                ...this.selectedWatchbezel2,
                                ...this.selectedWatchbezel3,
                                ...this.selectedWatchbezel4,
                                ...this.selectedWatchbezel5,
                                ...this.selectedWatchbezel6,
                            ];

                            arrLen=allSelected.length
                        }
                        blockLeftEl.classList.toggle('hidden', arrLen < 1);
                    }
                }

            }

        }
        updateBlockSummary(selectArr,type){
                let name = '';
                let total = 0;
                if(selectArr && selectArr.length > 0) {
                     //console.log(this.selectedWatchhead);
                    selectArr.forEach((item, idx)=>{
                        if(name == ''){
                            name = item.title;
                        }

                        const price = item.priceNumber || 0;
                        const priceCents = Math.round(price * 100); // 转为分，避免浮点
                        total += priceCents;
                       
                    })

                    if(selectArr.length > 1){
                        name = name + '...'
                    }
                    
                }

                const blcokEl=this.querySelector(`.panel-content .${type}`);
                if(blcokEl){
                    const titleEl= blcokEl.querySelector('.title-right .title-txt');
                    if(titleEl){
                        titleEl.innerHTML = name;
                    }
                    const priceEl= blcokEl.querySelector('.title-right .title-price');
                    if(priceEl){
                        if(total>0){
                            const finalTotal = total / 100; 
                            const priceStr = this.currencyIsoCode + ' ' + finalTotal;
                            priceEl.innerHTML = priceStr;
                            this.configuration[type]=finalTotal;
                        }else{
                            priceEl.innerHTML = '';
                            this.configuration[type]=0;
                        }
                        
                    }
                }

        }

        updateConfigurationSummary(config) {

            const priceEl=this.querySelector(`.panel-configuration .panel-summary .total-price`);
            if(priceEl){
                let totalCents = 0;
                for (const key in config) {
                    const value = config[key];
                    if (typeof value === 'number') {
                        totalCents += Math.round(value * 100);
                    }
                }
                const finalTotal = totalCents / 100;
                if(finalTotal > 0){
                    const priceStr = this.currencyIsoCode + ' ' + finalTotal;
                    priceEl.innerHTML = priceStr;
                }else{
                    priceEl.innerHTML = '';
                }

            }

        }

        updateMediaSummary(config) {

            const priceEl=this.section.querySelector(`.media-viewer .media-wrapper-top .media-wrapper-top-price`);
            if(priceEl){
                let totalCents = 0;
                for (const key in config) {
                    const value = config[key];
                    if (typeof value === 'number') {
                        totalCents += Math.round(value * 100);
                    }
                }
                const finalTotal = totalCents / 100;
                if(finalTotal > 0){
                    const priceStr = this.currencyIsoCode + ' ' + finalTotal;
                    priceEl.innerHTML = priceStr;
                }else{
                    priceEl.innerHTML = '';
                }

            }

        }
        //type 
        updateSummary2(type) {
            // 1. 汇总表头
            if ((type=='all'  || type=='watchhead')){
                this.updateBlockSummary(this.selectedWatchhead,'watchhead');
                this.updateConfigurationList(this.selectedWatchhead,'watchhead');
            } 

            //2.汇总表框
            if ((type=='all'  || type=='watchbezel1')){
                this.updateBlockSummary(this.selectedWatchbezel1,'watchbezel1');
                this.updateConfigurationList(this.selectedWatchbezel1,'watchbezel1');
            }

            if ((type=='all'  || type=='watchbezel2')){
                this.updateBlockSummary(this.selectedWatchbezel2,'watchbezel2');
                this.updateConfigurationList(this.selectedWatchbezel2,'watchbezel2');
            }

            if ((type=='all'  || type=='watchbezel3')){
                this.updateBlockSummary(this.selectedWatchbezel3,'watchbezel3');
                this.updateConfigurationList(this.selectedWatchbezel3,'watchbezel3');
            }

            if ((type=='all'  || type=='watchbezel4')){
                this.updateBlockSummary(this.selectedWatchbezel4,'watchbezel4');
                this.updateConfigurationList(this.selectedWatchbezel4,'watchbezel4');
            }

            if ((type=='all'  || type=='watchbezel5')){
                this.updateBlockSummary(this.selectedWatchbezel5,'watchbezel5');
                this.updateConfigurationList(this.selectedWatchbezel5,'watchbezel5');
            }

            if ((type=='all'  || type=='watchbezel6')){
                this.updateBlockSummary(this.selectedWatchbezel6,'watchbezel6');
                this.updateConfigurationList(this.selectedWatchbezel6,'watchbezel6');
            }
            //3. 汇总表带

            if ((type=='all'  || type=='watchstrap')){
                this.updateBlockSummary(this.selectedWatchstrap,'watchstrap');
                this.updateConfigurationList(this.selectedWatchstrap,'watchstrap');
            }
            
            //4. 汇总表冠
             if ((type=='all'  || type=='watchcrown')){
                this.updateBlockSummary(this.selectedWatchcrown,'watchcrown');
                this.updateConfigurationList(this.selectedWatchcrown,'watchcrown');
            }

            this.updateConfigurationSummary(this.configuration);
            this.updateMediaSummary(this.configuration);

        }
        updateBlockInput(selectArr,type,fristSelectedVariant){
            console.log(selectArr);
            const watchheadInputBlockEl= this.form.querySelector(`.${type}`);
            if(watchheadInputBlockEl){
                watchheadInputBlockEl.innerHTML ='';
                selectArr.forEach((item,idx)=>{
                    if(item.id != fristSelectedVariant.id){
                            
                            
                            const idInput = document.createElement('input');
                            idInput.type = 'hidden';
                            idInput.name = 'items[][id]';
                            idInput.value = item.id;
                            idInput.className = 'batch-item';
                            watchheadInputBlockEl.appendChild(idInput);

                            const qtyInput = document.createElement('input');
                            qtyInput.type = 'hidden';
                            qtyInput.name = 'items[][quantity]';
                            qtyInput.value = '1';
                            qtyInput.className = 'batch-item';
                            watchheadInputBlockEl.appendChild(qtyInput);
                    }
                })
            }
                        
          }
          updateVariantInput(type) {
            this.form = this.form || this.section.querySelector('.js-product-form-main, .js-product-form-main');
            if(this.form){
                const allSelected = [
                    ...this.selectedWatchhead,
                    ...this.selectedWatchbezel1,
                    ...this.selectedWatchbezel2,
                    ...this.selectedWatchbezel3,
                    ...this.selectedWatchbezel4,
                    ...this.selectedWatchbezel5,
                    ...this.selectedWatchbezel6,
                    ...this.selectedWatchstrap,
                    ...this.selectedWatchcrown
                ];
                let fristSelectedVariant = {};
                if(allSelected.length > 0){
                    fristSelectedVariant = allSelected[0];
                    const input = this.form.querySelector('.form-main-variant input[name="id"]');
                    input.value = fristSelectedVariant.id;
                    input.disabled=false;
                    input.dispatchEvent(new Event('change', { bubbles: true }));

                }else{
                    const input = this.form.querySelector('.form-main-variant input[name="id"]');
                    input.disabled=true;
                }
                    if(type=='all'  ||  type=='watchhead'){
                        this.updateBlockInput(this.selectedWatchhead,'watchhead',fristSelectedVariant);
                    }
                    if(type=='all'  ||  type=='watchbezel1'){
                        //console.log("watchbezel1");
                       // console.log(this.selectedWatchbezel1);
                        this.updateBlockInput(this.selectedWatchbezel1,'watchbezel1',fristSelectedVariant);
                    }
                    if(type=='all'  ||  type=='watchbezel2'){
                        this.updateBlockInput(this.selectedWatchbezel2,'watchbezel2',fristSelectedVariant);
                    }
                    if(type=='all'  || type=='watchbezel3'){
                        this.updateBlockInput(this.selectedWatchbezel3,'watchbezel3',fristSelectedVariant);
                    }
                    if(type=='all'  || type=='watchbezel4'){
                        this.updateBlockInput(this.selectedWatchbezel4,'watchbezel4',fristSelectedVariant);
                    }
                    if(type=='all'  || type=='watchbezel5'){
                        this.updateBlockInput(this.selectedWatchbezel5,'watchbezel5',fristSelectedVariant);
                    }
                    if(type=='all'  || type=='watchbezel6'){
                        this.updateBlockInput(this.selectedWatchbezel6,'watchbezel6',fristSelectedVariant);
                    }
                    if(type=='all'  || type=='watchstrap'){
                        this.updateBlockInput(this.selectedWatchstrap,'watchstrap',fristSelectedVariant);
                    }
                    if(type=='all'  || type=='watchcrown'){
                        this.updateBlockInput(this.selectedWatchcrown,'watchcrown',fristSelectedVariant);
                    }

                    

            }
            
           

      
        }
        updateBlockMedia(selectedArray,blockClass,type){
             const layerEl= this.section.querySelector(`.${blockClass} .${type}`);
             //console.log("layerEl")
                 //console.log(viewerMedaiEl)
                if(layerEl){
                    // 取最后一个选中对象
                    const variant = selectedArray.length > 0 ? selectedArray[selectedArray.length - 1] : null;
                    //console.log(variant)
                    if (variant && variant.viewerMedia) {
                        // 更新图片
                        // 查找或创建 img 元素
                        let img = layerEl.querySelector('img');
                        if (!img) {
                            img = document.createElement('img');
                            img.className = 'zoom-btn-img-fit zoom-btn-img-fit--cover';
                            img.alt = '';
                            img.loading = 'lazy';
                            layerEl.appendChild(img);
                        }

                        // 预加载
                        const newImg = new Image();
                        newImg.onload = () => {
                            img.src = variant.viewerMedia;
                            img.srcset = '';
                            img.style.opacity = '1';
                            img.onload = null;
                        };
                        newImg.onerror = () => {
                            // 加载失败：可设置占位图，或清空
                            img.src = ''; // 或者一个默认占位图
                            img.style.opacity = '0.3';
                        };
                        newImg.src = variant.viewerMedia;

                        // 加载中的过渡
                        img.style.transition = 'opacity 0.3s ease';
                        img.style.opacity = '0.3';

                    } else {
                    // 清空图片
                        layerEl.innerHTML='';
                    }

                }
        }

        
        updateviewerMedia(type){
            if(type=='all' ||  type=='watchhead'){
                this.updateBlockMedia(this.selectedWatchhead,"media-wrapper-zoom","watchhead");
                this.updateBlockMedia(this.selectedWatchhead,"modal-content","watchhead");
            }

            if(type=='all'  ||  type=='watchbezel1' ||  type=='watchbezel2' ||  type=='watchbezel3' ||  type=='watchbezel4' ||  type=='watchbezel5' ||  type=='watchbezel6'){
                const allSelectedWatchbezel = [
                    ...this.selectedWatchbezel1,
                    ...this.selectedWatchbezel2,
                    ...this.selectedWatchbezel3,
                    ...this.selectedWatchbezel4,
                    ...this.selectedWatchbezel5,
                    ...this.selectedWatchbezel6,
                    ];
                if(type=='all'){
                    this.updateBlockMedia(allSelectedWatchbezel,"media-wrapper-zoom","watchbezel");
                    this.updateBlockMedia(allSelectedWatchbezel,"modal-content","watchbezel");
                }
                if(type =='watchbezel1' ){
                    if(this.selectedWatchbezel1.length>0){
                        this.updateBlockMedia(this.selectedWatchbezel1,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(this.selectedWatchbezel1,"modal-content","watchbezel");
                    }else{
                        this.updateBlockMedia(allSelectedWatchbezel,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(allSelectedWatchbezel,"modal-content","watchbezel");
                    }
                    
                }

                if(type =='watchbezel2' ){
                    if(this.selectedWatchbezel2.length>0){
                        this.updateBlockMedia(this.selectedWatchbezel2,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(this.selectedWatchbezel2,"modal-content","watchbezel");
                    }else{
                        this.updateBlockMedia(allSelectedWatchbezel,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(allSelectedWatchbezel,"modal-content","watchbezel");
                    }
                }
                
                if(type =='watchbezel3' ){
                    if(this.selectedWatchbezel3.length>0){
                        this.updateBlockMedia(this.selectedWatchbezel3,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(this.selectedWatchbezel3,"modal-content","watchbezel");
                    }else{
                        this.updateBlockMedia(allSelectedWatchbezel,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(allSelectedWatchbezel,"modal-content","watchbezel");
                    }
                    
                }
                if(type =='watchbezel4' ){
                    if(this.selectedWatchbezel4.length>0){
                        this.updateBlockMedia(this.selectedWatchbezel4,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(this.selectedWatchbezel4,"modal-content","watchbezel");
                    }else{
                        this.updateBlockMedia(allSelectedWatchbezel,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(allSelectedWatchbezel,"modal-content","watchbezel");
                    }
                    
                }

                if(type=='watchbezel5' ){
                    if(this.selectedWatchbezel5.length>0){
                        this.updateBlockMedia(this.selectedWatchbezel5,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(this.selectedWatchbezel5,"modal-content","watchbezel");
                    }else{
                        this.updateBlockMedia(allSelectedWatchbezel,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(allSelectedWatchbezel,"modal-content","watchbezel");
                    }
                    
                }

                if(type=='watchbezel6' ){
                    if(this.selectedWatchbezel6){
                        this.updateBlockMedia(this.selectedWatchbezel6,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(this.selectedWatchbezel6,"modal-content","watchbezel");
                    }else{
                        this.updateBlockMedia(allSelectedWatchbezel,"media-wrapper-zoom","watchbezel");
                        this.updateBlockMedia(allSelectedWatchbezel,"modal-content","watchbezel");
                    }
                    
                }

            }

            if(type=='all'  || type=='watchstrap' ){
                this.updateBlockMedia(this.selectedWatchstrap,"media-wrapper-zoom","watchstrap");
                this.updateBlockMedia(this.selectedWatchstrap,"modal-content","watchstrap");
            }
            if(type=='all'  || type=='watchcrown' ){
                this.updateBlockMedia(this.selectedWatchcrown,"media-wrapper-zoom","watchcrown");
                this.updateBlockMedia(this.selectedWatchcrown,"modal-content","watchcrown");
            }
           
        }


        // ---------- 统一的事件处理器 ----------
        handleChange(event) {
            const target = event.target;
            //console.log('tab:',target)
            // 区分事件来源
            if (target.matches('.panel-tab-options-group .opt-btn')) {
                // 选项卡切换
                if (target.checked) {
                    //this.switchTab(target.value);
                    const tabValue = target.dataset.tab; // 获取 data-tab
                    // 或者使用 target.value 也可以
                    //console.log('切换选项卡，data-tab:', tabValue);
                    this.switchTab(tabValue);
                }
            } else if (target.matches('.panel-content .opt-btn')) {
                // 内部配件选项变化
                this.handleOptionChange(target);
            }
        }
        // ---------- 切换选项卡 ----------
        switchTab(tabValue) {
            //console.log(tabValue)
            this.resetDefaultSelected();
            
            //this.currentTab = tabValue;
            this.selectedSerie = tabValue;
            // 更新选项卡样式（保证UI一致）
            const labels = this.querySelectorAll('.panel-tab-options-group .opt-label');
            const radios = this.querySelectorAll('.panel-tab-options-group .opt-btn');
            //radios.forEach((radio, idx) => {
                //radio.checked = (radio.value === tabValue);
                //labels[idx].classList.toggle('selected', radio.checked);
            //});
            // 重新渲染内容
            //this.renderPanelContent(tabValue);
             // 查找匹配的数据项
            const matched = this.data.allSeriesData.find(item => item.watchserie === tabValue);
            if (!matched) return;

            this.updateDesignStudioTitle(matched);
            // 渲染内容
            this.renderPanelContent2(matched);
            // 更新汇总（此时内部选项已重新生成，需等待DOM更新）
            //requestAnimationFrame(() => this.updateSummary());
        }

    

        // ---------- 处理内部选项变化 ----------
        handleOptionChange(input) {
            //console.log(input);
            const cate = input.dataset.cate;
            const variantId = input.dataset.id;
            // 更新选中样式（同一组内只保留一个 selected）
            // 放在类中或作为静态属性
            const BADGE_STYLES = {
            selected: 'fill: rgb(255, 255, 255); color: rgb(255, 255, 255); border: 0px solid rgb(225, 225, 225); background-color: rgb(67, 67, 67);',
            unselected: 'background-color: rgb(255, 255, 255); fill: rgb(67, 67, 67); color: rgb(67, 67, 67); border: 0px solid rgb(225, 225, 225);'
            };
           
            const item = input.closest('.opt-item');
            if (!item) return;

            const badge = item.querySelector('.multi-answer__badge');
            if (input.checked) {
                item.classList.add('selected');
                if (badge) {
                    badge.style.cssText = BADGE_STYLES.selected;
                    const badge_f = badge.closest('.thumbnail-badge');
                    if(badge_f){
                        badge_f.classList.add('selected');
                    }
                    
                }

                if(cate != null && variantId !=null ){
                    let formattedKey = null;
                    if(cate == 'watchhead'){
                        formattedKey='watchheadProductFormatted';
                         var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchhead.push(obj);
                                this.updateSummary2('watchhead');
                                this.updateVariantInput('watchhead');
                                this.updateviewerMedia('watchhead');
                        }
                        
                    }
                    if(cate == 'watchbezel1'){
                        formattedKey='watchbezelProduct1Formatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchbezel1.push(obj);
                                this.updateSummary2('watchbezel1');
                                this.updateVariantInput('watchbezel1');
                                this.updateviewerMedia('watchbezel1');
                        }
                    }
                    if(cate == 'watchbezel2'){
                        formattedKey='watchbezelProduct2Formatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchbezel2.push(obj);
                                this.updateSummary2('watchbezel2');
                                this.updateVariantInput('watchbezel2');
                                 this.updateviewerMedia('watchbezel2');
                        }
                    }
                    if(cate == 'watchbezel3'){
                        formattedKey='watchbezelProduct3Formatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchbezel3.push(obj);
                                this.updateSummary2('watchbezel3');
                                this.updateVariantInput('watchbezel3');
                                 this.updateviewerMedia('watchbezel3');
                        }
                    }
                    if(cate == 'watchbezel4'){
                        formattedKey='watchbezelProduct4Formatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchbezel4.push(obj);
                                this.updateSummary2('watchbezel4');
                                this.updateVariantInput('watchbezel4');
                                this.updateviewerMedia('watchbezel4');
                        }
                    }
                    if(cate == 'watchbezel5'){
                        formattedKey='watchbezelProduct5Formatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchbezel5.push(obj);
                                this.updateSummary2('watchbezel5');
                                this.updateVariantInput('watchbezel5');
                                 this.updateviewerMedia('watchbezel5');
                        }
                    }
                    if(cate == 'watchbezel6'){
                        formattedKey='watchbezelProduct6Formatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchbezel6.push(obj);
                                this.updateSummary2('watchbezel6');
                                this.updateVariantInput('watchbezel6');
                                 this.updateviewerMedia('watchbezel6');
                        }
                    }
                    if(cate == 'watchstrap'){
                        formattedKey='watchstrapProductFormatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchstrap.push(obj);
                                this.updateSummary2('watchstrap');
                                this.updateVariantInput('watchstrap');
                                this.updateviewerMedia('watchstrap');
                        }
                    }
                    if(cate == 'watchcrown'){
                        formattedKey='watchcrownProductFormatted';
                        var obj =  this.getSelectedByKeyVariantId(this.selectedSerie,formattedKey,variantId);
                        if(obj){
                                this.selectedWatchcrown.push(obj);
                                this.updateSummary2('watchcrown');
                                this.updateVariantInput('watchcrown');
                                this.updateviewerMedia('watchcrown');
                        }
                    }
                    
                    
                }
            } else {
                item.classList.remove('selected');
                if (badge){
                    badge.style.cssText = BADGE_STYLES.unselected;
                    const badge_f = badge.closest('.thumbnail-badge');
                    if(badge_f){
                        badge_f.classList.remove('selected');
                    }
                    
                }

                if(cate != null && variantId !=null ){
                    const formattedKey = null;
                    if(cate == 'watchhead'){
                        const index = this.selectedWatchhead.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchhead.splice(index, 1);
                            this.updateSummary2('watchhead');
                            this.updateVariantInput('watchhead');
                             this.updateviewerMedia('watchhead');
                        }
                    }
                    if(cate == 'watchbezel1'){
                        const index = this.selectedWatchbezel1.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchbezel1.splice(index, 1);
                            this.updateSummary2('watchbezel1');
                            this.updateVariantInput('watchbezel1');
                             this.updateviewerMedia('watchbezel1');
                        }
                    }
                    if(cate == 'watchbezel2'){
                        const index = this.selectedWatchbezel2.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchbezel2.splice(index, 1);
                            this.updateSummary2('watchbezel2');
                            this.updateVariantInput('watchbezel2');
                             this.updateviewerMedia('watchbezel2');
                        }
                    }
                    if(cate == 'watchbezel3'){
                        const index = this.selectedWatchbezel3.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchbezel3.splice(index, 1);
                            this.updateSummary2('watchbezel3');
                            this.updateVariantInput('watchbezel3');
                             this.updateviewerMedia('watchbezel3');
                        }
                    }
                    if(cate == 'watchbezel4'){
                        const index = this.selectedWatchbezel4.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchbezel4.splice(index, 1);
                            this.updateSummary2('watchbezel4');
                            this.updateVariantInput('watchbezel4');
                             this.updateviewerMedia('watchbezel4');
                        }
                    }
                    if(cate == 'watchbezel5'){
                        const index = this.selectedWatchbezel5.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchbezel5.splice(index, 1);
                            this.updateSummary2('watchbezel5');
                            this.updateVariantInput('watchbezel5');
                             this.updateviewerMedia('watchbezel5');
                        }
                    }
                    if(cate == 'watchbezel6'){
                        const index = this.selectedWatchbezel6.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchbezel6.splice(index, 1);
                            this.updateSummary2('watchbezel6');
                            this.updateVariantInput('watchbezel6');
                             this.updateviewerMedia('watchbezel6');
                        }
                    }
                    if(cate == 'watchstrap'){
                        const index = this.selectedWatchstrap.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchstrap.splice(index, 1);
                            this.updateSummary2('watchstrap');
                            this.updateVariantInput('watchstrap');
                            this.updateviewerMedia('watchstrap');
                        }
                    }
                    if(cate == 'watchcrown'){
                        const index = this.selectedWatchcrown.findIndex(item => item.id === variantId);
                        if (index !== -1) {
                            this.selectedWatchcrown.splice(index, 1);
                            this.updateSummary2('watchcrown');
                            this.updateVariantInput('watchcrown');
                            this.updateviewerMedia('watchcrown');
                        }
                    }
                    
                    
                }
            }

            //this.updateSummary2('all');
            // 更新汇总
            //this.updateSummary();
        }

        updateDesignStudioTitle(matched){
            const designStudioTitle = this.querySelector('.design-panel .design-studio-title');
            if (designStudioTitle) {
                designStudioTitle.innerHTML=`${matched.designStudioTitle}`
            }

            const mediaWrapperTopTitle = this.section.querySelector(`.media-viewer .media-wrapper-top .media-wrapper-top-title`);
            if (mediaWrapperTopTitle) {
                mediaWrapperTopTitle.innerHTML=`${matched.designStudioTitle}`
            }
        }

        // ---------- 渲染 panel-content ----------
        renderPanelContent2(matched) {
            const panel = this.querySelector('.panel-content');
            if (!panel) return;

            // 产品键及其对应的 Formatted 键
            const productKeys = [
                { productKey: 'watchheadProduct', formattedKey: 'watchheadProductFormatted', titleKey:'watchheadProductTitle'},
                { productKey: 'watchbezelProduct1', formattedKey: 'watchbezelProduct1Formatted', titleKey:'watchbezelProduct1Title'},
                { productKey: 'watchbezelProduct2', formattedKey: 'watchbezelProduct2Formatted', titleKey:'watchbezelProduct2Title' },
                { productKey: 'watchbezelProduct3', formattedKey: 'watchbezelProduct3Formatted', titleKey:'watchbezelProduct3Title' },
                { productKey: 'watchbezelProduct4', formattedKey: 'watchbezelProduct4Formatted', titleKey:'watchbezelProduct4Title' },
                { productKey: 'watchbezelProduct5', formattedKey: 'watchbezelProduct5Formatted', titleKey:'watchbezelProduct5Title' },
                { productKey: 'watchbezelProduct6', formattedKey: 'watchbezelProduct6Formatted', titleKey:'watchbezelProduct6Title' },
                { productKey: 'watchcrownProduct', formattedKey: 'watchcrownProductFormatted', titleKey:'watchcrownProductTitle' },
                { productKey: 'watchstrapProduct', formattedKey: 'watchstrapProductFormatted', titleKey:'watchstrapProductTitle' }
            ];

            
            // 提取非空的产品及其格式化数据
            const entries = productKeys
                .map(({ productKey, formattedKey,titleKey }) => {
                const product = matched[productKey];
               
                if (!product || !product.variants || product.variants.length === 0) return null;
                const formatted = matched[formattedKey] || null;
                
                const titleName=matched[titleKey] || '';

                return { productKey,product, formatted ,titleName};
                })
                .filter(entry => entry !== null);

            if (entries.length === 0) {
                panel.innerHTML = '<p>No options available for this series.</p>';
                return;
            }

            let html = '';
            entries.forEach(({ productKey,product, formatted,titleName }) => {
                const title = product.title || 'Accessory';
                const variants = product.variants || [];

                // 构建格式化数据的快速查找表（以 variant id 为键）
                const variantFormattedMap = {};
                if (formatted) {
                    
                    // 如果 formatted 有 variants 数组
                    if (Array.isArray(formatted.variants)) {
                        formatted.variants.forEach(fv => {
                        if (fv.id) variantFormattedMap[fv.id] = fv;
                        });
                    } else if (typeof formatted === 'object') {
                        // 如果 formatted 是以 variant id 为键的对象
                        Object.keys(formatted).forEach(key => {
                        if (formatted[key] && typeof formatted[key] === 'object') {
                            variantFormattedMap[key] = formatted[key];
                            
                        }
                        });
                    }
                }

                let selectedTitle ='';
                let selectedPrice = '';
                
                let blockClass='';
                if(productKey=='watchheadProduct')
                    blockClass='watchhead';
                if(productKey=='watchbezelProduct1')
                    blockClass='watchbezel1';
                if(productKey=='watchbezelProduct2')
                    blockClass='watchbezel2';
                if(productKey=='watchbezelProduct3')
                    blockClass='watchbezel3';
                if(productKey=='watchbezelProduct4')
                    blockClass='watchbezel4';
                if(productKey=='watchbezelProduct5')
                    blockClass='watchbezel5';
                if(productKey=='watchbezelProduct6')
                    blockClass='watchbezel6';
                if(productKey=='watchstrapProduct')
                    blockClass='watchstrap';
                if(productKey=='watchcrownProduct')
                    blockClass='watchcrown';

                const optionsHtml = variants.map((variant, idx) => {
                    if(variant.available){

                    
                        const fv = variantFormattedMap[variant.id] || {};

                        // 价格：优先用 formatted 中的价格，否则从 variant.price 计算
                        let priceStr = fv.price;
                        if (!priceStr) {
                            //priceStr = (variant.price / 100).toFixed(2);
                        }
                        // 如果价格不是以 € 开头，则添加
                        /*
                        if (typeof priceStr === 'string' && !priceStr.includes('€')) {
                            priceStr = `€${priceStr}`;
                        } else if (typeof priceStr === 'number') {
                            priceStr = `€${priceStr.toFixed(2)}`;
                        }*/

                        const imageSrc = variant.featured_image?.src || product.featured_image || '';
                        const optionTitle = fv.title || variant.title || variant.option1 || 'Option';
                        const id = `opt-${product.id}-${variant.id}`;
                        //const checked = idx === 0 ? 'checked' : '';
                        //const selectedClass = idx === 0 ? 'selected' : '';
                        //const badgeStyle = idx === 0 ? this.BADGE_SELECTED : this.BADGE_UNSELECTED;
                        const checked = fv.is_select ? 'checked' : '';
                        const selectedClass = fv.is_select ? 'selected' : '';
                        const badgeStyle = fv.is_select ? this.BADGE_SELECTED : this.BADGE_UNSELECTED;
                        if(fv.is_select){
                            selectedTitle =  optionTitle;
                            selectedPrice =  priceStr;
                        }

                        //console.log(selectedTitle)
                        //console.log(selectedPrice)
                        return `
                            <div class="opt-item ${selectedClass}">
                            <div class="thumbnail-badge ${selectedClass}">
                                <div class="multi-answer__badge" style="${badgeStyle}">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" aria-label="Multi answer icon">
                                    <title>add</title>
                                    <path d="M0 12a1.5 1.5 0 0 0 1.5 1.5h8.75a.25.25 0 0 1 .25.25v8.75a1.5 1.5 0 0 0 3 0v-8.75a.25.25 0 0 1 .25-.25h8.75a1.5 1.5 0 0 0 0-3h-8.75a.25.25 0 0 1-.25-.25V1.5a1.5 1.5 0 0 0-3 0v8.75a.25.25 0 0 1-.25.25H1.5A1.5 1.5 0 0 0 0 12"></path>
                                </svg>
                                </div>
                            </div>
                            <input class="opt-btn visually-hidden focus-label js-option" data-cate="${blockClass}" data-id="${ variant.id }" type="checkbox" id="${id}" name="${product.id}" value="${variant.id}" ${checked}>
                            <label class="opt-label opt-label--swatch opt-label--image relative swatch-shape--circle swatch--variant-image" for="${id}">
                                <div class="opt-label__media">
                                <img src="${imageSrc}" alt="${optionTitle}" loading="lazy" draggable="false">
                                </div>
                            </label>
                            <span class="opt-price">${priceStr}</span>
                            <span class="opt-title">${optionTitle}</span>
                            </div>
                        `;
                    }
                }).join('');
                


                if (optionsHtml) {
                html += `
                    <fieldset class="option-selector value_size_40 more_then_ten ${blockClass}">
                    <legend class="panel-header panel-title label"><div class="title-left">${titleName}</div><div class="title-right"><span class="title-txt"> ${selectedTitle} </span><span class="title-price"> ${selectedPrice} </span></div></legend>
                    <div class="panel-options-group option-selector__btns flex flex-wrap items-start swatch_type_new">
                        ${optionsHtml}
                    </div>
                    </fieldset>
                `;
                }
            });

            panel.innerHTML = html;

            this.selectedData();
            this.updateSummary2('all');
            this.updateVariantInput('all');
            this.updateviewerMedia('all');
        }


        handleBadgeClick(event) {
            // 找到被点击的 .thumbnail-badge（或它的父级）
            const badge = event.target.closest('.thumbnail-badge');
            if (!badge) return;                     // 不是点击 badge，忽略

            const item = badge.closest('.opt-item');
            if (!item) return;

            const input = item.querySelector('.opt-btn');
            if (!input) return;

            // 切换选中状态（如果 checked 为 true 则变为 false，反之亦然）
            input.checked = !input.checked;

            // 手动触发 change 事件，让现有的 handleChange 接管后续处理（更新样式、数据、汇总等）
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        // ---------- 更新汇总 ----------
        updateSummary() {
            const shadow = this.shadowRoot;
            // 获取所有选中的 checkbox
            const checkedInputs = shadow.querySelectorAll('.panel-content .opt-btn:checked');
            let total = 0;
            let headName = '-';
            let crownName = '-';
            let headPrice = 0;
            let crownPrice = 0;

            checkedInputs.forEach(input => {
                const item = input.closest('.opt-item');
                if (!item) return;
                const priceEl = item.querySelector('.opt-price');
                const titleEl = item.querySelector('.opt-title');
                if (!priceEl || !titleEl) return;
                const price = parseFloat(priceEl.textContent.replace('€', '')) || 0;
                total += price;

                // 根据 input 的 name (product id) 判断类别
                const productId = input.name; // 对应 product.id
                // 简单判断：如果 productId 与 watchheadProduct 的 id 匹配，则为表头
                // 为了通用，我们使用 product 的 title 包含 'Head' 或 'Crown' 等，但更可靠的是在渲染时存储类别
                // 这里我们简单用 title 包含 "Head" 或 "Crown"
                const title = titleEl.textContent;
                // 尝试从当前数据中获取类别，但这里简化：通过 title 或 input 的 name 前缀判断
                // 更好的做法：在渲染时给 input 添加 data-category 属性。为简化，我们用产品 id 的前缀判断
                // 由于产品 id 是数字，无法直接判断，我们可以在渲染时添加 data-category
                // 我们快速调整：在渲染时给 input 添加 data-category，这里先不做修改，利用标题包含 'Head' 或 'Crown'
                // 因为产品标题通常包含这些词
                const productTitle = item.closest('fieldset')?.querySelector('legend')?.textContent || '';
                if (productTitle.includes('Head')) {
                headName = title;
                headPrice = price;
                } else if (productTitle.includes('Crown')) {
                crownName = title;
                crownPrice = price;
                }
                // 如果有多个表头或表冠，只会记录最后一个，但通常只有一个
            });

            // 更新DOM
            const headNameSpan = shadow.getElementById('headName');
            const headPriceSpan = shadow.getElementById('headPrice');
            const crownNameSpan = shadow.getElementById('crownName');
            const crownPriceSpan = shadow.getElementById('crownPrice');
            const totalSpan = shadow.getElementById('totalPrice');

            if (headNameSpan) headNameSpan.textContent = headName;
            if (headPriceSpan) headPriceSpan.textContent = `€${headPrice.toFixed(2)}`;
            if (crownNameSpan) crownNameSpan.textContent = crownName;
            if (crownPriceSpan) crownPriceSpan.textContent = `€${crownPrice.toFixed(2)}`;
            if (totalSpan) totalSpan.textContent = `€${total.toFixed(2)}`;
        }

        getSeriesData(serieName) {
            return this.data.find(item => item.watchserie === serieName) || null;
        }

        getCurrentTab() {
            // 查找选项卡组中 checked 的 radio
            const checkedRadio = this.querySelector('.panel-tab-options-group .opt-btn:checked');

            if (checkedRadio) {
                // 优先使用 data-tab，如果没有则回退到 value
                return checkedRadio.dataset.tab || checkedRadio.value;
            }else{
                return null;
            }

        }

        /**
         * Gets the product data.
         * @returns {?object}
         */
        getDesignStudioData() {
            const dataEl = this.querySelector('[type="application/json"]');
            return JSON.parse(dataEl.textContent);
        }
    }

    customElements.define('design-studio-picker', DesignStudioPicker);
}
